<div class="target-ach-container">
    <customer-select class="customer-selector sm:hidden mx:block"
        style="display: flex; justify-content: end;"></customer-select>
    <!-- <div class="header-devider"></div> -->
    <div class="bg-error text-base min-h-[48px] flex-v-center mt-2 justify-between"
        *ngIf="annualResult && (annualResult.overdueCount || annualResult.expectedRebateDeduction)">
        <div class="flex items-center">
            <svg-icon [iconName]="'new/info.svg'" [size]="20" class="mr-3 ml-4"></svg-icon>
            <div>
                <span>本年度已逾期付款{{annualResult.overdueCount}}次<span
                        *ngIf="annualResult && annualResult.overdueCount && annualResult.expectedRebateDeduction">，</span></span><span>预计扣除{{annualResult.expectedRebateDeduction}}比例的返利金额</span>
            </div>
        </div>
    </div>
    <div class="statistic-cards mt-2">
        <ng-container *ngFor="let item of indicatorList">
            <nz-card
              *ngIf="hasPermission(item.key) && item.value != null && item.value != 0"
              [style.background]="(item.value === 0 || item.value == null ? '#d9d9d9' : item.color)"
              class="cursor-pointer text-[#ffffff]"
              [class.opacity-50]="item.value === 0 || item.value == null"
              [class.pointer-events-none]="item.value === 0 || item.value == null"
              (click)="onCardClick(item.value, item.tab)"
            >
              <div style="font-size: 16px;" class="text-center">{{ item.label }}<i nz-icon nzType="exclamation-circle" nzTheme="outline"
                nz-tooltip
                [nzTooltipTitle]="item.tips"
                class="ml-2 cursor-pointer">
             </i></div>
              <div style="font-size: 24px;" class="text-center font-black">{{ item.value | number }}</div>
            </nz-card>
          </ng-container>
    </div>
    <nz-page-header [nzTitle]="'主合同年度目标达成: '+pageHeaderTitle">
        <nz-page-header-extra>
            <span style="font-size: 16px;">数据更新时间：{{latestUpdateTime}}</span>
            <nz-select [(ngModel)]="selectedYear" style="width: 100px; margin-left: 8px"
                (ngModelChange)="onYearChange($event)">
                <nz-option *ngFor="let year of yearList" [nzValue]="year" [nzLabel]="year"></nz-option>
            </nz-select>
            <div>数据截至上一个工作日，仅供参考，请以线下结算为准。</div>
        </nz-page-header-extra>
    </nz-page-header>

    <div class="annual-target">
          <div class="bg-error text-base min-h-[48px] flex-v-center mb-2 justify-between" *ngIf="annualResult && annualResult.ssqSignStatus!=='签署成功'">
            <div class="flex items-center">
              <svg-icon [iconName]="'new/info.svg'" [size]="20" class="mr-3 ml-4"></svg-icon>
              <div>
                <div>上上签合同尚未签署，数据仅供参考。</div>
              </div>
            </div>
          </div>
        <div class="dashboard-row">
            <nz-card class="progress-card">
                <div class="chart-header">
                    <div class="chart-title">年度采购数据</div>
                    <div class="chart-title-unit">单位：元</div>
                </div>

                <div style="text-align: center;" *ngIf="(annualOverview.annualPurchaseTarget === '-' || annualOverview.annualPurchaseTarget === '0')
                                && (annualOverview.actualPurchaseAmount === '-' || annualOverview.actualPurchaseAmount === '0');
                                                    else noFeatureName1">
                    <img style="margin: 0 auto;" src="assets/target/no-purchase-data.png" />
                    <span>当前暂无年度数据~</span>
                </div>
                <ng-template #noFeatureName1>
                    <div class="progress-chart">
                        <div class="circle">
                            <nz-progress class="annual-progress" nzType="circle"
                                [nzPercent]="(annualOverview.currentTargetAchievement * 100).toFixed(0)"
                                [nzStrokeColor]="'#00884A'" [nzWidth]="180" [nzFormat]="percentFormat"></nz-progress>
                        </div>
                        <div class="info">
                            <div class="info-1">年度采购目标</div>
                            <div class="info-2">{{roundWithCommas(annualOverview.annualPurchaseTarget)}}</div>
                            <div class="devider"></div>
                            <div class="info-3">实际已完成采购额</div>
                            <div class="info-4">{{roundWithCommas(annualOverview.actualPurchaseAmount)}}</div>
                        </div>
                    </div>
                    <div class="w-full rounded-md mt-10" *ngIf="annualResult.annualRebateAmount!==0">
                        <div class="flex justify-between">
                            <div class="text-[18px] mb-1">
                                目标返利金额 <i nz-icon nzType="exclamation-circle" nzTheme="outline"
                                nz-tooltip
                                nzTooltipTitle="目标返利金额（含税）：按照合同约定完成目标后可得含税返利金额"
                                class="mx-1 cursor-pointer">
                             </i> <span class="font-bold text-[20px]"> {{annualResult.annualRebateAmount | number:'1.0-0' }}</span>
                              </div>
                              <div class="text-[18px] mb-2">
                                奖励比例: {{(annualResult.annualRewardRatio* 100).toFixed(1)}}%
                              </div>
                        </div>
                        <div class="relative">
                            <nz-progress
                              nzType="line"
                              [nzPercent]="(annualOverview.currentTargetAchievement * 100).toFixed(0)"
                              [nzStrokeColor]="'#007BC0'"
                              [nzShowInfo]="false"
                              class="custom-progress"
                              [nzStrokeWidth]="16"
                            ></nz-progress>
                            <span class="absolute inset-0 flex items-center justify-center text-white text-xs font-medium mt-1">
                              {{ formatPercent(annualOverview.currentTargetAchievement) }}
                            </span>
                          </div>
                    </div>
                </ng-template>
            </nz-card>
            <nz-card class="progress-card">
                <div class="chart-header">
                    <div class="chart-title">季度采购数据</div>
                    <div class="chart-title-unit">单位：元</div>
                </div>
                <div style="text-align: center;" *ngIf="(annualOverview.quarterlyTarget === '-' || annualOverview.quarterlyTarget === '0')
                                    && (annualOverview.quarterlyPendingPurchaseAmount === '-' || annualOverview.quarterlyPendingPurchaseAmount === '0');
                                    else noFeatureName2">
                    <img style="margin: 0 auto;" src="assets/target/no-purchase-data.png" />
                    <span>当前暂无季度数据~</span>
                </div>
                <ng-template #noFeatureName2>
                    <div class="progress-chart">
                        <div class="circle">
                            <nz-progress class="quarterly-progress" nzType="circle"
                                [nzPercent]="calculatePercentage(annualOverview.quarterlyPendingPurchaseAmount, annualOverview.quarterlyTarget)"
                                [nzStrokeColor]="'#9E2896'" [nzWidth]="180" [nzFormat]="percentFormat"></nz-progress>
                        </div>
                        <div class="info">
                            <div class="info-1">截止本季度目标</div>
                            <div class="info-2">{{roundWithCommas(annualOverview.quarterlyTarget)}}</div>
                            <div class="devider"></div>
                            <div class="info-3">当前季度待完成采购额</div>
                            <div class="info-5">{{roundWithCommas(annualOverview.quarterlyPendingPurchaseAmount)}}</div>
                        </div>
                    </div>
                    <div class="w-full rounded-md mt-10" *ngIf="annualResult.quarterlyRebateAmount!==0">
                        <div class="flex justify-between">
                            <div class="text-[18px] mb-1">
                                目标返利金额<i nz-icon nzType="exclamation-circle" nzTheme="outline"
                                nz-tooltip
                                nzTooltipTitle="目标返利金额（含税）：按照合同约定完成目标后可得含税返利金额"
                                class="mx-1 cursor-pointer">
                             </i> <span class="font-bold text-[20px]">{{annualResult.quarterlyRebateAmount | number:'1.0-0' }}</span>
                              </div>
                        </div>
                        <div class="relative">
                            <nz-progress
                              nzType="line"
                              [nzPercent]="calculatePercentage(annualOverview.quarterlyPendingPurchaseAmount, annualOverview.quarterlyTarget)"
                              [nzStrokeColor]="'#007BC0'"
                              [nzShowInfo]="false"
                              class="custom-progress"
                              [nzStrokeWidth]="16"
                            ></nz-progress>
                            <span class="absolute inset-0 flex items-center justify-center text-white text-xs font-medium mt-1">
                                {{ calculatePercentage(annualOverview.quarterlyPendingPurchaseAmount, annualOverview.quarterlyTarget) }}%
                            </span>
                          </div>
                    </div>
                </ng-template>
            </nz-card>
        </div>
    </div>
    <nz-page-header nzTitle="年度产品线目标与采购"></nz-page-header>
    <div class="product-line-summary">
        <div class="row" *ngFor="let row of rows">
            <div *ngFor="let product of row" class="item" [style.width]="cardWidth + '%'">
                <div class="item-content">
                    <!-- <div style="font-size: 16px;">{{ product.productLineNameCn }}</div>
                    <div style="display: flex; margin-top: 10px; align-items: center;">
                        <div style="font-size: 24px; font-weight: bold;">{{ product?.completionRate ?
                            (product.completionRate * 100).toFixed(0) : 0 }}%</div>
                        <img style="margin-left: auto;" [src]="product.icon">
                    </div> -->
                    <div style="display: flex;">
                        <div style="font-size: 16px; display: grid;">
                            <span style="font-weight: bold;">{{ product.productLineNameCn }}</span>
                            <span style="margin-top: 10px;">年度目标：</span>
                            <span>{{ product.annualTarget }}</span>
                        </div>
                        <div class="circle" style="margin-left: auto;">
                            <nz-progress class="productline-progress" nzType="circle" [nzPercent]="product?.completionRate && product?.completionRate!='-'?
                            (product.completionRate * 100).toFixed(0) : 0" [nzStrokeColor]="'#007BC0'" [nzWidth]="90"
                                [nzFormat]="percentFormat"></nz-progress>
                        </div>
                    </div>

                    <div class="w-full rounded-md mt-6">
                        <div class="text-base mb-1">
                          目标返利金额 <span class="font-bold text-[20px]">{{product.targetRebateAmount | number:'1.0-0' }}</span>
                        </div>
                        <div class="text-[14px] mb-2">
                          奖励比例: {{(product.rewardRatio* 100).toFixed(1)}}%
                        </div>

                        <div class="relative">
                            <nz-progress
                              nzType="line"
                              [nzPercent]="product?.completionRate && product?.completionRate!='-' ?
                            (product.completionRate * 100).toFixed(0) : 0"
                              [nzStrokeColor]="'#007BC0'"
                              [nzShowInfo]="false"
                              class="custom-progress"
                              [nzStrokeWidth]="16"
                            ></nz-progress>
                            <span class="absolute inset-0 flex items-center justify-center text-white text-xs font-medium mt-1">
                              {{ product?.completionRate && product?.completionRate!='-' ?
                                (product.completionRate * 100).toFixed(0) : 0 }}%
                            </span>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <nz-table #sortTable [nzData]="cbfTarget" (nzQueryParams)="onQueryParamsChange($event)" [nzBordered]="true"
        [nzScroll]="{ x: '1000px' }" [nzFrontPagination]="false">
        <thead>
            <tr>
                <th [style.width.px]="140" nzColumnKey="productLineNameCn" [nzSortFn]="true">产品线</th>

                <th [style.width.px]="160" nzColumnKey="annualTarget" [nzSortFn]="true">
                    年度目标
                    <!-- <br /><span class="sub-header">2025.07.11 10:00更新</span> -->
                </th>

                <th [style.width.px]="160" nzColumnKey="monthlyTarget" [nzSortFn]="true">
                    截至本月目标
                    <!-- <br /><span class="sub-header">单位：元</span> -->
                </th>

                <th [style.width.px]="160" nzColumnKey="purchaseAmount" [nzSortFn]="true">截至本月采购金额<br /></th>
                <th [style.width.px]="180" nzColumnKey="pendingAmountYTM" [nzSortFn]="true">截至本月待完成金额<br /></th>
                <th [style.width.px]="160" nzColumnKey="progress" [nzSortFn]="true">截至本月完成进度<br /></th>
                <th [style.width.px]="140" nzColumnKey="pendingPaymentAmount" [nzSortFn]="true">待付款金额<br /></th>
                <th [style.width.px]="140" nzColumnKey="openOrderAmount" [nzSortFn]="true">开放订单金额<br /></th>
                <th [style.width.px]="140" nzColumnKey="warehouseAmount" [nzSortFn]="true">仓库处理金额<br /></th>
                <!-- <th [style.width.px]="160">未到货订单金额<br /></th>
                <th [style.width.px]="160">仓库处理中金额<br /></th>
                <th nzRight [style.width.px]="60">操作</th> -->
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let item of sortTable.data">
                <td>{{ item.productLineNameCn }}</td>
                <td>{{ item.annualTarget}}</td>
                <td>{{ item.monthlyTarget}}</td>
                <td>{{ roundWithCommas(item.purchaseAmount)}}</td>
                <td>{{ roundWithCommas(item.pendingAmountYTM)}}</td>
                <td>
                    <nz-progress [nzPercent]="item.progress" [nzStrokeColor]="{ '0%': '#108ee9', '100%': '#87d068' }"
                        [nzShowInfo]="true"></nz-progress>
                </td>
                <td>{{ roundWithCommas(item.pendingPaymentAmount) }}</td>
                <td>{{ roundWithCommas(item.openOrderAmount) }}</td>
                <td>{{ roundWithCommas(item.warehouseAmount) }}</td>
                <!-- <td>{{ item.pendingAmount | number }}</td>
                <td>{{ item.totalAmount | number }}</td>
                <td nzRight>
                    <i nz-icon nzType="file-search" class="action-icon"></i>
                </td> -->
            </tr>
        </tbody>
    </nz-table>
</div>
